var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d62427.46441322061!2d-77.0296179!3d-12.0630149!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses-419!2spe!4v1663273023802!5m2!1ses-419!2spe","width":"100%","height":"800","allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})
}
var staticRenderFns = []

export { render, staticRenderFns }